// src/components/Testimonials/TestimonialsManager.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTestimonials,
  insertTestimonial,
  updateTestimonial,
  deleteTestimonial,
} from "../../../store/testimonialsSlice";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../Styles/Common.css";

const blank = {
  id: "",
  feedbackMsg: "",
  learnerName: "",
  learnerImg: null,   // File on upload
  status: "A",
};

function TestimonialsManager() {
  const dispatch = useDispatch();
  const { items: testimonials = [], loading, error } = useSelector(s=>s.testimonials);

  /* ui */
  const [search, setSearch] = useState("");
  const [popup, setPopup] = useState(false);
  const [edit,  setEdit ]  = useState(false);
  const [form,  setForm ]  = useState(blank);
  const sanitizeUrl = (url) => url.replace(/([^:])\/\//g, "$1/");

  /* fetch once */
  useEffect(()=>{ dispatch(fetchTestimonials()); },[dispatch]);

  /* file choose */
  const handleFile=e=>{
    if(e.target.files[0]){
      setForm(p=>({...p, learnerImg:e.target.files[0]}));
    }
  };

  /* save */
  const save=async e=>{
    e.preventDefault();
    try{
      if(edit) await dispatch(updateTestimonial(form)).unwrap();
      else     await dispatch(insertTestimonial(form)).unwrap();
      toast.success(edit?"Updated":"Added");
      setPopup(false); setForm(blank);
    }catch(err){ toast.error("Save failed"); }
  };

  /* delete */
  const del=async id=>{
    if(window.confirm("Delete testimonial?")){
      try{ await dispatch(deleteTestimonial(id)).unwrap();
           toast.success("Deleted");}
      catch{ toast.error("Delete failed");}
    }
  };

  const startAdd = ()=>{ setForm(blank); setEdit(false); setPopup(true); };
  const startEdit = t=>{
    setForm({...t, learnerImg:null});    // don't auto-load file
    setEdit(true); setPopup(true);
  };

  /* filter */
  const shown = testimonials.filter(t=>t.learnerName.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="trainer-container">
      <ToastContainer position="bottom-right" autoClose={2500}/>
      <div className="header-container">
        <h2>Testimonials</h2>
        <button className="add-lead-btn" onClick={startAdd}><i className="fa fa-plus"/></button>
      </div>

      <input className="filter-input" placeholder="search learner..."
             value={search} onChange={e=>setSearch(e.target.value)}/>

      {loading && <p>Loading…</p>}
      {error && <p className="error">{error}</p>}

      <table className="table">
        <thead>
          <tr><th>#</th><th>Learner</th><th>Message</th><th>Pic</th><th>Status</th><th>Created</th><th>⋯</th></tr>
        </thead>
        <tbody>
          {shown.map((t,i)=>(
            <tr key={t.id}>
              <td>{i+1}</td>
              <td>{t.learnerName}</td>
              <td style={{maxWidth:300,whiteSpace:"pre-wrap"}}>{t.feedbackMsg}</td>
              <td>
                {t.learnerImg
                  ?
                    <img
                        src={sanitizeUrl(`https://iteyonikservicesinstitute.com/${t.learnerImg}`)}
                        alt="ICT Event"
                        className="ict-img"
                        width="80"
                        height="50"
                    />
                  : "—"}
              </td>
              <td>{t.status}</td>
              <td>{new Date(t.created).toLocaleDateString()}</td>
              <td>
                <button className="icon-btn update-btn fa fa-edit"
                        onClick={()=>startEdit(t)}/>
                <button className="icon-btn delete-btn fa fa-trash"
                        onClick={()=>del(t.id)}/>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* popup */}
      {popup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>{edit?"Edit":"Add"} Testimonial</h3>
            <form onSubmit={save}>
              <div className="form-group">
                <label> Learner Name </label>
                <input value={form.learnerName}
                       onChange={e=>setForm({...form, learnerName:e.target.value})}
                       required/>
              </div>

              <div className="form-group">
                <label> Feedback </label>
                <textarea value={form.feedbackMsg}
                          onChange={e=>setForm({...form, feedbackMsg:e.target.value})}
                          required />
              </div>

              <div className="form-group">
                <label> Picture (.jpg/.png)</label>
                <input type="file" accept="image/*" onChange={handleFile}
                       required={!edit}/>
                {edit && typeof form.learnerImg==="string" && (
                  <p style={{fontSize:"0.8em"}}>Current: {form.learnerImg}</p>
                )}
              </div>

              <div className="form-group">
                <label>Status</label>
                <select value={form.status}
                        onChange={e=>setForm({...form,status:e.target.value})}>
                  <option value="A">Active</option>
                  <option value="D">Disabled</option>
                </select>
              </div>

              <div className="form-actions">
                <button type="submit">
                  {edit?<i className="fa fa-save"/>:<i className="fa fa-plus-square"/>}
                </button>
                <button type="button" className="fa fa-close" onClick={()=>setPopup(false)}/>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default TestimonialsManager;
